import type { CrmObject } from '@/types/crm';

import type { HighlightDefinition } from '../registry/entityTypeRegistry';
import { AssociationCountHighlightCard } from './AssociationCountHighlightCard';
import { AssociationHighlightCard } from './AssociationHighlightCard';
import { ComputedHighlightCard } from './ComputedHighlightCard';
import { EntityCountHighlightCard } from './EntityCountHighlightCard';
import { LastEventHighlightCard } from './LastEventHighlightCard';
import { LastPropertyUpdateHighlightCard } from './LastPropertyUpdateHighlightCard';
import { PropertyHighlightCard } from './PropertyHighlightCard';

interface Props {
  definition: HighlightDefinition;
  object: CrmObject;
  orgId: number;
}

export function HighlightCard({ definition, object, orgId }: Props) {
  switch (definition.kind) {
    case 'property':
      return (
        <PropertyHighlightCard
          definition={definition}
          object={object}
          orgId={orgId}
        />
      );
    case 'association':
      return (
        <AssociationHighlightCard
          definition={definition}
          object={object}
          orgId={orgId}
        />
      );
    case 'association_count':
      return (
        <AssociationCountHighlightCard
          definition={definition}
          object={object}
          orgId={orgId}
        />
      );
    case 'entity_count':
      return (
        <EntityCountHighlightCard
          definition={definition}
          object={object}
          orgId={orgId}
        />
      );
    case 'last_event':
      return (
        <LastEventHighlightCard
          definition={definition}
          object={object}
          orgId={orgId}
        />
      );
    case 'last_property_update':
      return (
        <LastPropertyUpdateHighlightCard
          definition={definition}
          object={object}
          orgId={orgId}
        />
      );
    case 'computed':
      return (
        <ComputedHighlightCard
          label={definition.label}
          compute={definition.compute}
          object={object}
          orgId={orgId}
        />
      );
    default: {
      const _exhaustive: never = definition;
      void _exhaustive;
      return null;
    }
  }
}
